export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const isLgUp = () => window.innerWidth > 992;
